import { useState, useEffect } from 'react'

/**
 * 윈도우 크기를 추적하는 커스텀 훅
 * @returns {number} 현재 윈도우 너비 (픽셀)
 */
export const useWindowSize = () => {
	const [width, setWidth] = useState(() => {
		// SSR 대응: window 객체가 없을 경우 기본값 반환
		if (typeof window !== 'undefined') {
			return window.innerWidth
		}
		return 1024 // 기본값
	})

	useEffect(() => {
		const handleResize = () => setWidth(window.innerWidth)
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return width
}

/**
 * 모바일 화면 여부를 판단하는 커스텀 훅
 * @param {number} breakpoint - 모바일 기준 너비 (기본값: 480px)
 * @returns {boolean} 모바일 화면 여부
 */
export const useIsMobile = (breakpoint = 480) => {
	const width = useWindowSize()
	return width < breakpoint
}
